import { APP_STORE_STATUS_TO_CHECK_STATUS_MAP, PARTNER_CODE_ENGINE_MAP, APP_STORE_PAPER_CHECK_STATUS_TYPE } from './contant';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { DiscountDetail, PriceDetail } from './CustomTypeAndInterface';
import { CHECK_STATUS_TYPE, CHECK_ERROR_TYPE } from './contant';

dayjs.extend(utc);

export const getFileType = (file: File) => {
  let name = file.name;
  return name.slice(name.lastIndexOf('.') + 1).toLowerCase();
}

export const getFileNameWithoutSuffix = (file: File) => {
  let name = file.name;
  return name.slice(0, name.lastIndexOf('.'));
}


/**
 * @description 使用setTimeout模拟setInterVal
 * @parmas fn callback, 
 *        1、定时器停止的时机需要 fn 返回 是否停止，在 mySetInterval函数内容进行停止： eg: let mySetIntervalInstance = mySetInterval(() => {}, 1000), 需要停止的时候 执行 mySetIntervalInstance()
 *        2、fn需要传入参数的话可以在 使用mySetInterval的时候bind参数列表: eg: mySetInterval((() => {}).bind(null, 1,2), 1000) fn在执行的时候就会有2个参数值是 1，2
 *         
 * @params delay 间隔时间
 * @returns 返回停止计数器函数
*/
export function mySetInterval(fn: any, delay = 0) {
	let timerId = null;
	let isOutClear = false;
	let clear = (isInner = false) => {
		isOutClear = isInner;
		clearTimeout(timerId);
		timerId = null;
	}
	let _fn = () => {
		if (isOutClear || !timerId) {
			return;
		}
		let isStop = fn();
		if (isStop && isStop instanceof Promise) {
			isStop.then(_isStop => {
				if (_isStop) {
					clear()
					return;
				}
				timerId = setTimeout(_fn, delay);
			}).catch(() => {
				timerId = setTimeout(_fn, delay);
			});
		} else {
			if (isStop) {
				clear()
				return;
			}
			timerId = setTimeout(_fn, delay);
		}
	}
	timerId = setTimeout(_fn, delay);
	return clear;
}

export const utcTimeToLocalTime = (time: string, format = 'YYYY-MM-DD HH:mm:ss') => {
	return dayjs.utc(time).local().format(format)
}

function isValidDate(date: Date) {
	return date.toString() !== 'Invalid Date';
}

export const formatStringNumber = (stringNumber: string | number) => {
	return isNaN(Number(stringNumber)) ? 0 : Number(stringNumber)
}

function formatDiscountDetail(discount: any) {
	if (!discount) {
		return undefined;
	}
	let { price, start_date, end_date, percent, ...other } = discount;
	return {
		price: formatStringNumber(price),
		percent: formatStringNumber(percent),
		start_date: start_date.replace(/-/g, '/'),
		end_date: end_date.replace(/-/g, '/'),
		...other
	}
}

export const formatPriceDetail = (price_detail: PriceDetail) => {
	let { new_discount, published_discount, published, new: _new } = price_detail;
	return {
		new: formatStringNumber(_new),
		published: formatStringNumber(published),
		new_discount: new_discount && formatDiscountDetail(new_discount),
		published_discount: published_discount && formatDiscountDetail(published_discount)
	}
}

/**
 * @description 是否在优惠时间
 * @param price_detail 价格详情
 * @param checkType 检测类型
 * @returns 是否在优惠时间
 * 
*/
export const isInDiscountDateUtil = (price_detail: PriceDetail, checkType: string) => {
	let discount = price_detail[`${checkType}_discount`] as DiscountDetail;
	if (!discount) {
		return false;
	} else {
		let { start_date, end_date} = discount;
		let startDate = new Date(start_date);
		let endDate = new Date(`${end_date} 23:59:59`);
		if (!isValidDate(startDate) && !isValidDate(endDate)) {
			return false;
		} else {
			let nowTime =  Date.now()
			if (nowTime < startDate.getTime() || nowTime > endDate.getTime()) {
				return false;
			} else {
				return true;
			}
		}
	}
}

export const getDiscountTimeRange = (discount: DiscountDetail, format: string = 'M.D') => {
	let { start_date, end_date} = discount;
	let startDate = dayjs(new Date(start_date)).format(format);
	let endDate = dayjs(new Date(end_date)).format(format);
	return `${startDate}-${endDate}`;
}

export const getDiscountNoticeDisplayedStorageKey = (discount: DiscountDetail) => {
	let { start_date, end_date} = discount;
	let startDate = start_date.replace(/\//g, '');
	let endDate = end_date.replace(/\//g, '');
	return `DiscountNoticeFrom${startDate}To${endDate}Displayed`;
}

function getStampTime(time: string) {
	let stamp = 0;
	if (time) {
		let date = new Date(time);
		if (isValidDate(date)) {
			stamp = date.getTime();
		}
	}
	return stamp;
}

export function formatPaperCheckOrderData(checkOrderData: any) {
	if (!checkOrderData || typeof checkOrderData !== 'object') {
		return;
	}
	let {
		order_uuid: orderId,
		checkId,
		check_title: checkTitle,
		author: checkAuthor,
		check_letter_counts,
		check_total_price,
		check_file_type: checkFileType,
		check_type: checkType,
		check_engine,
		check_status,
		abstract_date: checkPublishDate,
		check_error_type: checkErrorType,
		check_start_time: checkStartTime,
		payment_info,
		check_total_copy_percent,
		created
	} = checkOrderData;
	let payment_success_date = '';
	let _payment_info;
	if (payment_info) {
		try {
			_payment_info = JSON.parse(payment_info);
			payment_success_date = _payment_info.response.payment_success_date;
			payment_success_date = utcTimeToLocalTime(payment_success_date);
		} catch (err) {
		}
	}
	let formatData = {
		orderId,
		checkId,
		checkTitle,
		checkAuthor,
		checkLetterCounts: formatStringNumber(check_letter_counts),
		checkTotalPrice: formatStringNumber(check_total_price),
		checkFileType,
		checkType,
		checkEngine: PARTNER_CODE_ENGINE_MAP[check_engine],
		checkStatus: APP_STORE_STATUS_TO_CHECK_STATUS_MAP[check_status],
		checkPublishDate,
		checkErrorType,
		checkOrderTime: payment_success_date,
		checkOrderTimeStamp: getStampTime(payment_success_date),
		createdTime: utcTimeToLocalTime(created),
		createdTimeStamp: getStampTime(utcTimeToLocalTime(created)),
		payment_success_date,
		payment_info: _payment_info,
		checkStartTime: checkStartTime ? utcTimeToLocalTime(checkStartTime) : '',
		checkTotalCopyPercent: formatStringNumber(check_total_copy_percent)
	}
	return {
		...checkOrderData,
		...formatData
	}
}
